import script from "./LeftSideBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeftSideBlock.vue?vue&type=script&lang=ts&setup=true"

import "./LeftSideBlock.vue?vue&type=style&index=0&id=3712a83c&lang=scss"

const __exports__ = script;

export default __exports__